import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';
import { DATES } from 'app/_constants/dates.constant';

(() => {
    'use strict';

    /**
     * @ngdoc controller
     * @name TsoDashboardCtrl
     * @memberof app
     *
     * @description
     * Hello everyone!
     * We love to improve user experience and we’ve made it our devoted job
     * to improve users’ happiness with this carefully designed dashboard.
     * Sincerely yours
     * Mars <3
     *
     * @author flzemke.btc
     */
    angular.module('app').controller('TsoDashboardCtrl', TsoDashboardCtrl);

    function TsoDashboardCtrl(
        $rootScope,
        authService,
        $location,
        tsoNotificationResource,
        ttpcModulationService,
        DATES: DATES
    ) {
        var vm = this;
        vm.loggedInUser = null;
        vm.tsoNotifications = 'test';
        vm.loadingError = false;
        vm.loadingData = true;
        vm.notificationsHaveBeenAvailableInitially = false;
        vm.queryLastXDays = 30;
        vm.calculatedSinceDate = moment()
            .subtract(vm.queryLastXDays, 'days')
            .toDate();

        vm.ttpcModulationServiceUrl =
            $rootScope.stageConfig.appBaseUrl + '/modulation-service-auctions';
        vm.DATES = DATES;
        tsoNotificationResource
            .queryUnprocessedSince(
                { sinceDate: vm.calculatedSinceDate },
                (res: TsoNotificationDto[]) => {
                    vm.tsoNotifications = res;
                    vm.loadingError = false;
                    vm.loadingData = false;
                },
                () => {
                    vm.loadingError = true;
                    vm.loadingData = false;
                }
            )
            .$promise.finally(() => {
                vm.notificationsHaveBeenAvailableInitially =
                    this.tsoNotifications.length > 0;
            });

        authService.userLoginPromise.promise.then(
            (loginResult: LoginResult) => {
                if (!!loginResult) {
                    vm.loggedInUser = loginResult;
                    if (vm.loggedInUser.role == 'TSO_USER') {
                        // $location.url('/settings');
                    }
                }
            }
        );

        ttpcModulationService.data.then((data) => {
            vm.isTtpcModulationServiceEnabled =
                data.active && data.isManagingTso;
            vm.ttpcAuctionTileInformation = data.auctionTileInformation;
        });
    }
})();
